import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import { flexCenter } from '@seedlang/style_mixins';
import { formatNumber } from '@seedlang/utils';
import { ChatOutlineIcon2 } from '@seedlang/icons';

const Wrapper = styled.div`
  ${flexCenter()}
  gap: ${props => props.showCommentIcon ? '6px' : 0};
  justify-content: flex-start;
  width: ${props => props.width || (props.showCommentIcon ? '56px' : '50px')};
  height: 30px;
  color: #656565;
  font-size: ${props => props.showCommentIcon ? '12px' : '14px'};
  font-weight: bold;
  .chat-outline-icon2 {
    height: 16px;
    width: 16px;
    svg {
      fill: #656565;
      width: 16px;
    }
  }
`;

@observer
class ForumCount extends React.Component {

  render() {
    return (
      <Wrapper
        showCommentIcon={this.props.showCommentIcon}
        width={this.props.width}
      >
        {
          this.props.showCommentIcon &&
            <ChatOutlineIcon2 />
        }
        {formatNumber(this.props.count)}
      </Wrapper>
    );
  }
}

export default ErrorBoundary(ForumCount);
